import type {ReactElement} from 'react';
import {ControlledSlider} from '@Components/controlled-slider';
import {useAppSelector} from '@/hooks';
import './page-slider.scss';
import {onPosterPause} from '@Components/poster-editor/library/poster-editor-library';
import {getPageCurrentTime, isPageVideo} from '@Components/poster-editor/poster-editor-reducer';

interface PageSliderProps {
  pageId: string;
}

export function PageSlider({...props}: PageSliderProps): ReactElement | null {
  const page = useAppSelector((state) => {
    return state.posterEditor.posterObject?.pages?.pagesHashMap[props.pageId];
  });
  const currentTime = useAppSelector((state) => getPageCurrentTime(state, props.pageId));
  const isVideoPage = useAppSelector((state) => isPageVideo(state, props.pageId));
  const isTimelineModeActive = useAppSelector((state) => {
    return state.posterEditor.isTimelineModeActive;
  });
  const isMobileVariant =
    useAppSelector((state) => {
      return state.posterEditor.isMobileVariant;
    }) ?? false;
  const seekPage = (newValue: number | number[]): void => {
    const targetPage = window.posterEditor?.whiteboard?.pages.pagesHashMap[props.pageId];
    if (!targetPage) {
      return;
    }
    void targetPage.seek(newValue as number);
  };

  if (!page || !isVideoPage || isMobileVariant) {
    return null;
  }

  if (page.duration === 0) {
    return null;
  }

  const onSlide = (value: number): void => {
    onPosterPause();
    seekPage(value);
  };

  return <ControlledSlider className={`page-slider ${isTimelineModeActive ? '_hidden' : ''}`} value={currentTime} step={0.01} min={0} max={page.duration} onSlide={onSlide} />;
}
